import React from 'react';
import {useParams} from "react-router-dom";
import AdminSystemLayout from "@containers/adminSystem/layout/AdminSystemLayout";
import AdminAccountEdit from "@containers/adminAccounts/edit/AdminAccountEdit";

export const AdminAccountEditPage = () => {

	const {accountId} = useParams()

	return (
		<AdminSystemLayout>
			<AdminAccountEdit key={accountId} accountId={Number(accountId)}/>
		</AdminSystemLayout>
	)
};

export default AdminAccountEditPage;
